// extracted by mini-css-extract-plugin
export default {"root":"classes_root__yCmH-","content":"classes_content__MIsic"};